import type { CSSProperties } from 'react';
import styled from 'styled-components';
import type { BoxProps } from '@frameio/vapor';
import { Box, theme } from '@frameio/vapor';

type DividerProps = BoxProps & {
  style?: CSSProperties;
};

export function QuickSearchListDivider({ style, ...boxProps }: DividerProps) {
  return (
    <Box {...boxProps} style={style}>
      <ListDivider />
    </Box>
  );
}

const ListDivider = styled.div`
  background-color: ${theme.colors.border.primary};
  height: 2px;
  width: 100%;

  /* Hide on mobile (base breakpoint) */
  @media (max-width: ${theme.breakpoints.tablet}) {
    display: none;
  }
`;
